import { QuestionType } from '@constants/surveys';

export const getPreviousQuestionTitles = (questions, key) =>
    Object.entries(questions)
        .filter(([k]) => Number(k) < Number(key))
        .map(([, langs]) => langs[0]?.title)
        .filter(Boolean);

export const isQuestionValid = (question, previousTitles) => {
    if (!question.title || !question.question) return false;

    const type = question.type || QuestionType.RATING;
    const isChoiceType = type === QuestionType.SINGLE_CHOICE || type === QuestionType.MULTI_SELECT;
    const visibleOptions = (question.options || []).filter(o => !o.hidden);
    if (isChoiceType && visibleOptions.length < 2) return false;
    if (isChoiceType && !visibleOptions.every(o => !!o.label?.trim())) return false;

    return (question.conditions || []).every(
        cond => !!cond.questionTitle && previousTitles.includes(cond.questionTitle) && !!cond.values?.length,
    );
};
